export enum QuotationStates {
  Ongoing = 1,
  Study = 2,
  Converted = 3,
  Abandoned = 4,
  Expired = 5,
  ToValidate = 6
}
